import './App.css';
import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import SiteLoader from './views/components/SiteLoader';
import { message } from 'antd';
import ThemeChanger from './ThemeChanger';
import commonObj from './commonObj';
import service from './services/user';
import PrivacyPolicy from './views/pages/PrivacyPolicy';

const LayoutAdmin = React.lazy(() => import('./views/layout/Layout'));
const Login = React.lazy(() => import('./views/pages/Login'));
const Apk = React.lazy(() => import('./views/pages/Apk'));



function App() {
	const [isLoggedin, setIsLoggedin] = useState(false);
	const [ajxRequesting, setAjxRequesting] = useState(false);


	useEffect(() => {
  if (window.location.pathname === '/nagpal-account/app' || window.location.pathname === '/nagpal-account/app/privacy-policy') {
    setAjxRequesting(false);
    return;
  }

  setAjxRequesting(true);
  service
    .validateToken()
    .then((res) => {
      setIsLoggedin(true);
      commonObj.userType = res.data.type;
      commonObj.modules = res.data.modules;
      commonObj.name = res.data.name;
      commonObj.avatar = res.data.avatar;
      message.success(res.message);
    })
    .catch((err) => {
      setIsLoggedin(false);
      window.localStorage.clear();
      message.error("Unauthorized. Login Again!!");
    })
    .finally(() => {
      setAjxRequesting(false);
    });
}, []);



	return (
    <>
      <BrowserRouter basename="/nagpal-account">
        <Suspense fallback={<SiteLoader />}>
          <Routes>
            <Route path="/app" element={<Apk />} />
            <Route path="/app/privacy-policy" element={<PrivacyPolicy/>} />


            <Route
              path="/*"
              element={
                !ajxRequesting ? (
                  isLoggedin ? (
                    <LayoutAdmin />
                  ) : (
                    <Login />
                  )
                ) : (
                  <SiteLoader />
                )
              }
            />
          </Routes>
        </Suspense>
      </BrowserRouter>

      <ThemeChanger />
    </>
  );
}

export default App;
